import { FormattedMessage } from 'react-intl';

import { BankAccountVerificationOption } from './BankAccountVerificationOption';
import styles from './ChooseNewBankAccountVerification.module.css';
import { TNewBankAccountModalName } from '../verifyNewBankAccountModal/VerifyNewBankAccountModal';

export const ChooseNewBankAccountVerification = ({
    changeVerificationMethod
}: {
    changeVerificationMethod: (method: TNewBankAccountModalName) => void;
}) => {
    return (
        <>
            <p className={styles.chooseVerificationMethodDescription}>
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.choose_verification_method_heading"
                    defaultMessage="We will use this account for loan disbursement and direct debit collection of your monthly repayments."
                />
            </p>
            <div className={styles.verificationOptions}>
                <BankAccountVerificationOption
                    header={
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.choose_verification_method_online_banking.title"
                            defaultMessage="Verify online"
                        />
                    }
                    message={
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.choose_verification_method_online_banking.message"
                            defaultMessage="Link your account in just a few clicks via Open Banking. Only your account number and name will be shared with us."
                        />
                    }
                    recommended={true}
                    onClick={() => {
                        changeVerificationMethod('open_banking');
                    }}
                />
                <BankAccountVerificationOption
                    header={
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.choose_verification_method_manual_upload.title"
                            defaultMessage="Upload a statement"
                        />
                    }
                    message={
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.choose_verification_method_manual_upload.message"
                            defaultMessage="Manually upload a bank statement to verify your bank details."
                        />
                    }
                    recommended={false}
                    onClick={() => {
                        changeVerificationMethod('manual_bs_upload');
                    }}
                />
            </div>
        </>
    );
};
